/** Given `['a', 'b', 'c']`, returns an union type string of the form `'a' | 'b' | 'c'`. */
export const arrayToUnionType = (values: string[]) => {
  if (!values.length) {
    return 'never';
  }
  return values.map(value => `'${value.replace(/'/g, "\\'")}'`).join(' | ');
};
